//
//
//
//
//
//
//
//
//

import { checkIOS } from '@/utils/wx_api'
function getBase64Image(img) {
    var canvas = document.createElement("canvas")
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext("2d")
    ctx.drawImage(img, 0, 0, img.width, img.height)
    var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase()
    var dataURL = canvas.toDataURL("image/"+ext)
    return dataURL
}
export default {
    data () {
        return {
            url: '',
            base64: '',
            name: ''
        }
    },
    created () {
        const { url, name } = this.$route.query
        this.url = decodeURIComponent(url)
        if (name) {
            this.name = name
        }
    },
    methods: {
        downloadImg () {
            console.log(this.url)
            this.$wx.downloadImg({
                url: this.base64,
                name: this.name,
                success: () => {
                    this.$wx.showToast({
                        title: '已保存到相册！'
                    })
                }
            })
        },
        load (e) {
            this.base64 = getBase64Image(e.target)
            console.log(this.base64)
        }
    }
}
